<template>
  <v-container
    class="pa-0"
  >
    <v-card
      flat
      tile
      class="pa-3"
    >
      <v-toolbar
        flat
      >
        <v-btn
          icon
          to="/eleaveAdmin/StaffSickList"
        >
          <v-icon>{{ mdiArrowLeft }}</v-icon>
        </v-btn>
        <v-toolbar-title>
          {{ $t('eleave.SickForm.Manage') }}
        </v-toolbar-title>
      </v-toolbar>

      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          {{ $t('eleave.PatientName') }}：<span class="underline">黃小小</span><br>
          {{ $t('eleave.SickStartDate') }}：<span class="underline">2019-08-29</span>
          <span class="ml-3">{{ $t('eleave.SickEndDate') }}：</span><span class="underline">2019-08-30</span>
          <br><br>
          {{ $t('eleave.DoctorStatement') }}：<br>

          {{ $t('eleave.StayAtHome') }} <br>

          {{ $t('eleave.StayInHospital') }} <br>

          {{ $t('eleave.StayWith') }} <br>

          {{ $t('eleave.DontNeedStayInHome') }} <br>

          {{ $t('eleave.NeedTreatment') }} <br>

          {{ $t('eleave.AfterHospital') }} <br>

          <br>
          湖畔嘉模衛生中心<br>
          林木森醫生 0205572

          <br><br><br>

          <h3 class="subtitle">
            {{ $t('eleave.Statement') }}
          </h3>

          <div>
            {{ $t('eleave.PersonalStatement') }}
            <span class="underline">AAAAAA</span>
            {{ $t('eleave.Sick.Days') }}
            <span class="underline">BBBBBB</span>
            {{ $t('eleave.Sick.Hours') }}
            <span class="underline">CCCCCC</span>
            {{ $t('eleave.Sick.Mins') }}
            <span class="underline">DDDDDD</span>
            {{ $t('eleave.CanFindMeHere') }}
            <span class="underline">EEEEEE</span>
          </div>

          <br><br>

          <h3 class="subtitle">
            {{ $t('eleave.Sick.GotNotice') }}
          </h3>

          <div
            v-for="(staff) in relatedStaffList"
            :key="staff.staffCode"
            class="pb-2"
          >
            {{ staff.name }} {{ staff.staffCode }}
          </div>

          <br>

          {{ $t('eleave.Sick.MsgFromStaff') }}<br>
          ABCDEFG ABCDEFG ABCDEFG ABCDEFG
        </v-col>

        <v-col
          cols="12"
          md="6"
        >
          <v-card
            elevation="4"
            class="pa-4"
          >
            <v-form>
              <div class="text-subtitle-1">
                {{ $t('PublicServant.Action.New') }} - {{ $t('eLeave.AbsenceData') }}
              </div>
              <v-row dense>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    value="DVE003549"
                    :label="$t('msg_entrada_code')"
                    disabled
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-select
                    v-model="selectedSickType"
                    :items="sickTypes"
                    outlined
                    :label="$t('msg_absent_nature_type_label')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    value="林木森"
                    :label="$t('eleave.Sick.DoctorName')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    value="湖畔嘉模衛生中心"
                    :label="$t('eleave.Sick.IssuePlace')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    value="2019-08-29"
                    :label="$t('eLeave.StartDate')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    value="2019-08-30"
                    :label="$t('eLeave.EndDate')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    :label="$t('eLeave.Obser')"
                  />
                </v-col>
              </v-row>

              <div class="d-flex">
                <v-btn>{{ $t('eleave.Sick.eSignLink') }}<v-icon>{{ mdiShareOutline }}</v-icon></v-btn>
                <v-spacer />
                <v-btn class="primary">
                  {{ $t('PublicServant.Action.Save') }}
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { mdiArrowLeft, mdiShareOutline } from '@mdi/js'

export default {
  components: {
  },
  data: function () {
    return {
      mdiShareOutline: mdiShareOutline,
      mdiArrowLeft: mdiArrowLeft,
      selectedSickType: '因病缺勤',
      sickTypes: ['因病缺勤', '因病缺勤 - 住院', '因病缺勤 - 休養'],
      relatedStaffList: [
        {
          staffCode: '000000001',
          name: '張一 Cheong'
        },
        {
          staffCode: '000000002',
          name: '李二二 Cheong'
        }
      ]
    }
  },
  methods: {
    addStaffToNotice: function () {
      if (this.searchStaffCode !== null) {
        let tStaff = { staffCode: this.searchStaffCode, name: '李李' }
        this.relatedStaffList.push(tStaff)
        this.searchStaffCode = null
      }
    }
  }
}
</script>
